import { Utils } from 'choerodon-ui/dataset';
const warning = Utils.warning;
export default warning;
